import { Action } from 'redux'

import { Vendor } from 'src/lib/interfaces/Vendor.interface'

export const actionTypes = {
  TOGGLE_SIDEBAR: 'CLOSE_SIDEBAR',

  // fetch vendors
  VENDORS_FETCH: 'VENDORS_FETCH',
  VENDORS_FETCH_SUCCESS: 'VENDORS_FETCH_SUCCESS',
  VENDORS_FETCH_ERROR: 'VENDORS_FETCH_ERROR',

  // fetch locations
  LOCATIONS_FETCH: 'LOCATIONS_FETCH',
  LOCATIONS_FETCH_SUCCESS: 'LOCATIONS_FETCH_SUCCESS',
  LOCATIONS_FETCH_ERROR: 'LOCATIONS_FETCH_ERROR',

  // fetch location positions
  LOCATION_POSITIONS_FETCH: 'LOCATION_POSITIONS_FETCH',
  LOCATION_POSITIONS_FETCH_SUCCESS: 'LOCATION_POSITIONS_FETCH_SUCCESS',
  LOCATION_POSITIONS_FETCH_ERROR: 'LOCATION_POSITIONS_FETCH_ERROR',

  ENTITY_DOWNLOAD_FILE: 'ENTITY_DOWNLOAD_FILE',
  ENTITY_DELETE_FILE: 'ENTITY_DELETE_FILE'
}

/**
 * Action to close sidebar
 */
export interface ToggleSidebarAction extends Action {
  payload: {
    state: boolean,
    next?: () => void
  }
}

export const toggleSidebarActionDispatchCommand = (state: boolean): ToggleSidebarAction => ({
  type: actionTypes.TOGGLE_SIDEBAR,
  payload: {
    state
  }
})

/**
 * Fetch vendors
 */
export interface VendorsFetchAction extends Action {
  payload: {
    next?: () => void
  }
}

export const fetchVendors = (next?: () => void): VendorsFetchAction => ({
  type: actionTypes.VENDORS_FETCH,
  payload: { next }
})

/**
 * Fetch vendors success
 */
export interface VendorsFetchSuccessAction extends Action {
  payload: {
    vendors: Vendor[]
  }
}

export const fetchVendorsSuccess = (vendors: Vendor[]): VendorsFetchSuccessAction => ({
  type: actionTypes.VENDORS_FETCH_SUCCESS,
  payload: { vendors }
})


/**
 * Fetch vendors error
 */
export interface VendorsFetchErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchVendorsError = (errorMessage: string): VendorsFetchErrorAction => ({
  type: actionTypes.VENDORS_FETCH_ERROR,
  payload: {
    errorMessage
  }
})

/**
 * Fetch locations
 */
export interface LocationsFetchAction extends Action {
  payload: {
    next?: () => void
  }
}

export const fetchLocationsDispatchCommand = (next?: () => void): LocationsFetchAction => ({
  type: actionTypes.LOCATIONS_FETCH,
  payload: { next }
})


/**
 * Fetch Locations success
 */
export interface LocationsFetchSuccessAction extends Action {
  payload: {
    locations: Location[]
  }
}

export const fetchLocationsSuccessDispatchCommand = (locations: Location[]): LocationsFetchSuccessAction => ({
  type: actionTypes.LOCATIONS_FETCH_SUCCESS,
  payload: { locations }
})


/**
 * Fetch Locations error
 */
export interface LocationsFetchErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchLocationsErrorDispatchCommand = (errorMessage: string): LocationsFetchErrorAction => ({
  type: actionTypes.LOCATIONS_FETCH_ERROR,
  payload: {
    errorMessage
  }
})

/**
 * Fetch location positions
 */
export interface LocationPositionsFetchAction extends Action {
  payload: {
    locationId: number
  }
}

export const fetchLocationPositions = (locationId: number): LocationPositionsFetchAction => ({
  type: actionTypes.LOCATION_POSITIONS_FETCH,
  payload: { locationId }
})


/**
 * Fetch location positions success
 */
export interface LocationPositionsFetchSuccessAction extends Action {
  payload: {
    locationId: number,
    positions: Position[]
  }
}

export const fetchLocationPositionsSuccess = (locationId: number, positions: Position[]): LocationPositionsFetchSuccessAction => ({
  type: actionTypes.LOCATION_POSITIONS_FETCH_SUCCESS,
  payload: { locationId, positions }
})


/**
 * Fetch location positions error
 */
export interface LocationPositionsFetchErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchLocationPositionsError = (errorMessage: string): LocationPositionsFetchErrorAction => ({
  type: actionTypes.LOCATION_POSITIONS_FETCH_ERROR,
  payload: {
    errorMessage
  }
})

/**
 * Download entity file
 */
export interface EntityDownloadFileAction extends Action {
  payload: {
    entity: string
    fileKey: string
    entityId: string|number
    next: (err?: any, file?: any) => void
  }
}

export const downloadEntityFile = (entity: string, entityId: string|number, fileKey: string, next: (err?: any, file?: any) => void): EntityDownloadFileAction => ({
  type: actionTypes.ENTITY_DOWNLOAD_FILE,
  payload: { entity, entityId, fileKey, next }
})

/**
 * Delete entity file
 */
export interface EntityDeleteFileAction extends Action {
  payload: {
    entity: string
    fileKey: string
    entityId: string|number
    next?: (err?: any) => void
  }
}

export const deleteEntityFile = (entity: string, entityId: string|number, fileKey: string, next?: (err?: any) => void): EntityDeleteFileAction => ({
  type: actionTypes.ENTITY_DELETE_FILE,
  payload: { entity, entityId, fileKey, next }
})

export type AppActionTypes =
  LocationsFetchAction |
  LocationsFetchSuccessAction |
  LocationsFetchErrorAction |
  EntityDownloadFileAction |
  EntityDeleteFileAction



// WEBPACK FOOTER //
// ./src/store/app/actions.ts